import React from "react";
import { CircleArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

function PageBackTitle({ children, className = "" }) {
  const navigate = useNavigate();

  return (
    <div className={`data-list-heading-content-left-side page-back-title ${className}`.trim()}>
      <button
        type="button"
        className="page-back-title-button"
        onClick={() => navigate(-1)}
        aria-label="Go back"
        title="Back"
      >
        <CircleArrowLeft size={22} strokeWidth={2.2} />
      </button>
      <span className="page-back-title-text">{children}</span>
    </div>
  );
}

export default PageBackTitle;
